"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseProjects = exports.FirebaseAppConfig = void 0;
exports.getFirebaseConfigForSpecificEnvironment = getFirebaseConfigForSpecificEnvironment;
exports.getFirebaseConfigForCurrentEnvironment = getFirebaseConfigForCurrentEnvironment;
const zod_1 = require("zod");
const firebaseEnvironment_1 = require("./firebaseEnvironment");
exports.FirebaseAppConfig = zod_1.z.object({
    projectId: zod_1.z.string(),
    apiKey: zod_1.z.string(),
    authDomain: zod_1.z.string(),
    databaseURL: zod_1.z.string(),
    storageBucket: zod_1.z.string(),
    messagingSenderId: zod_1.z.string(),
    appId: zod_1.z.string(),
    measurementId: zod_1.z.string(),
    serviceAccountId: zod_1.z.string().email(),
});
exports.FirebaseProjects = {
    production: {
        projectId: "graviton-mvp",
        appId: "1:706308333141:web:9c78f0286da170472b3edc",
        apiKey: "AIzaSyAXNgauDwq62Ev-SVuub9VrKrGn2eCE6KE",
        authDomain: "auth.flux.ai",
        databaseURL: "https://graviton-mvp.firebaseio.com",
        storageBucket: "graviton-mvp.appspot.com",
        messagingSenderId: "706308333141",
        measurementId: "G-SZ17792FZ5",
        // see https://console.cloud.google.com/iam-admin/iam?authuser=0&project=graviton-mvp&hl=en
        serviceAccountId: "firebase-adminsdk-m0nw5@graviton-mvp.iam.gserviceaccount.com",
    },
    staging: {
        projectId: "flux-staging-2e425",
        appId: "1:21695470325:web:47f584fe5e9c6c45d783bc",
        apiKey: "AIzaSyDB4uGVy6XKDlQlXQ03cjMs9pfbO0p0dss",
        authDomain: "flux-staging-2e425.firebaseapp.com",
        databaseURL: "https://flux-staging-2e425.firebaseio.com",
        storageBucket: "flux-staging-2e425.appspot.com",
        messagingSenderId: "21695470325",
        measurementId: "G-F2EWKKJ4T8",
        // see https://console.cloud.google.com/iam-admin/iam?authuser=0&project=flux-staging-2e425&hl=en
        serviceAccountId: "firebase-adminsdk-pr44s@flux-staging-2e425.iam.gserviceaccount.com",
    },
    emulated: {
        projectId: "demo-graviton-mvp",
        apiKey: "ABC",
        appId: "1:123:web:abc",
        authDomain: "auth.flux.ai",
        databaseURL: "http://127.0.0.1:8080",
        measurementId: "X-ABC",
        messagingSenderId: "123",
        storageBucket: `demo-graviton-mvp.example.com`,
        serviceAccountId: "firebase-adminsdk-example@graviton-mvp.iam.gserviceaccount.com",
    },
};
/**
 * Get the Firebase configuration for a specific environment
 */
function getFirebaseConfigForSpecificEnvironment(firebaseEnvironment) {
    return exports.FirebaseProjects[firebaseEnvironment];
}
/**
 * Get the current Firebase configuration from the given process environment variables
 */
function getFirebaseConfigForCurrentEnvironment(overrideProcessEnv = {}) {
    const environment = (0, firebaseEnvironment_1.getFirebaseEnvironment)(overrideProcessEnv);
    return getFirebaseConfigForSpecificEnvironment(environment);
}
//# sourceMappingURL=firebaseProjects.js.map